import { LoginResponse } from 'shared/api/auth/requests'

import { userApi } from '..'

export const changeUserPartner = async ({
  partnerId,
  userId
}: {
  userId: number
  partnerId: number
}) => {
  const response = await userApi.post<
    void,
    {
      data: {
        data: LoginResponse
      }
    }
  >(`${userId}/partners/${partnerId}/current`)
  return response.data.data
}
